/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import CollectWPListScene from '@/modules/service-point/scenes/collect-without-pin/order-list/collect-list.scene.vue';
import CollectOrderConfirmScene from '@/modules/service-point/scenes/collect/order-confirm/confirm.scene.vue';
import CollectOrderScanScene from '@/modules/service-point/scenes/collect/order-scan/scan.scene.vue';
import CollectOrderStatusScene from '@/modules/service-point/scenes/collect/order-status/status.scene.vue';
import DeliverWPConfirmScene from '@/modules/service-point/scenes/deliver-without-pin/order-confirm/confirm.scene.vue';
import DeliverWPListScene from '@/modules/service-point/scenes/deliver-without-pin/order-list/list.scene.vue';
import DeliverWPStatusScene from '@/modules/service-point/scenes/deliver-without-pin/order-status/status.scene.vue';
import DeliverOrderConfirmScene from '@/modules/service-point/scenes/deliver/order-confirm/confirm.scene.vue';
import DeliverOrderScanScene from '@/modules/service-point/scenes/deliver/order-scan/scan.scene.vue';
import DeliverOrderStatusScene from '@/modules/service-point/scenes/deliver/order-status/status.scene.vue';
import HomeScene from '@/modules/service-point/scenes/home/home.scene.vue';
import ReceivePackagesScanScene from '@/modules/service-point/scenes/receive/scan.scene.vue';
import ServicePointScene from '@/modules/service-point/scenes/service-point.scene.vue';
import UsersAddScene from '@/modules/service-point/scenes/users/add/users-add.scene.vue';
import UsersListScene from '@/modules/service-point/scenes/users/list/users-list.scene.vue';

/**
 * Route meta data.
 */
const meta = {
  requiresAuth: true
};

/**
 * Routes.
 */
export default [
  {
    children: [
      // Home route.
      {
        component: HomeScene,
        meta,
        name: 'ServicePointHome',
        path: 'home'
      },
      // Receive packages.
      {
        component: ReceivePackagesScanScene,
        meta,
        name: 'ServicePointReceivePackagesScan',
        path: 'receive-packages/scan'
      },
      // Deliver order.
      {
        component: DeliverOrderScanScene,
        meta,
        name: 'ServicePointDeliverOrderScan',
        path: 'deliver-order/scan'
      },
      {
        component: DeliverOrderConfirmScene,
        meta,
        name: 'ServicePointDeliverOrderConfirm',
        path: 'deliver-order/confirm'
      },
      {
        component: DeliverOrderStatusScene,
        meta,
        name: 'ServicePointDeliverOrderStatus',
        path: 'deliver-order/status'
      },
      {
        component: DeliverWPListScene,
        meta,
        name: 'ServicePointDeliverOrderWithoutPinList',
        path: 'deliver-order/without-pin/list'
      },
      {
        component: DeliverWPConfirmScene,
        meta,
        name: 'ServicePointDeliverOrderWithoutPinConfirm',
        path: 'deliver-order/without-pin/confirm',
        props: true
      },
      {
        component: DeliverWPStatusScene,
        meta,
        name: 'ServicePointDeliverOrderWithoutPinStatus',
        path: 'deliver-order/without-pin/status',
        props: true
      },
      // Users.
      {
        component: UsersAddScene,
        meta,
        name: 'ServicePointUsersAdd',
        path: 'users/add'
      },
      {
        component: UsersListScene,
        meta,
        name: 'ServicePointUsersList',
        path: 'users/list'
      },
      // Returns.
      {
        component: CollectWPListScene,
        meta,
        name: 'ServicePointCollectOrderWithoutPinList',
        path: 'collect-order/without-pin/list'
      },
      {
        component: CollectOrderScanScene,
        meta,
        name: 'ServicePointCollectOrderScan',
        path: 'collect-order/scan'
      },
      {
        component: CollectOrderConfirmScene,
        meta,
        name: 'ServicePointCollectOrderConfirm',
        path: 'collect-order/confirm'
      },
      {
        component: CollectOrderStatusScene,
        meta,
        name: 'ServicePointCollectOrderStatus',
        path: 'collect-order/status'
      }
    ],
    component: ServicePointScene,
    name: 'ServicePoint',
    path: '/service-point',
    redirect: { name: 'ServicePointHome' }
  }
] as RouteConfig[];
